export default __webpack_public_path__ + "static/media/firsthero.428267a0.png";